export var dataHooks = {
  suffix: 'formfield-suffix',
  labelIndicators: 'formfield-indicators'
};